import { useEffect, useMemo, useState } from 'react'

const usePromise = <T extends unknown>(fn: Promise<T>) => {
  const [promise, setPromise] = useState<T | null>(null)
  useEffect(() => {
    fn.then((res) => setPromise(res))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  return useMemo(() => promise, [promise])
}

export default usePromise
